import { c as _c } from "react/compiler-runtime";
import type { Option, Size } from '../../select.types';
import CustomItem from '../custom-item';
import CustomContent from './components/custom-content';
type SelectContentProps = {
  options: Option[];
  value: string;
  size: Size;
  ariaLabel?: string;
  contentProps?: import('@radix-ui/react-select').SelectContentProps;
};
const SelectContent = t0 => {
  const $ = _c(12);
  const {
    options,
    value,
    size,
    ariaLabel,
    contentProps
  } = t0;
  const t1 = options.length <= 2;
  let t2;
  if ($[0] !== options || $[1] !== size || $[2] !== value) {
    let t3;
    if ($[4] !== size || $[5] !== value) {
      t3 = option => <CustomItem size={size} showChecked={value === option.value} key={option.value} value={option.value} description={option.description} disabled={option.disabled}>{option.component ? option.component : option.label}</CustomItem>;
      $[4] = size;
      $[5] = value;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = options.map(t3);
    $[0] = options;
    $[1] = size;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[7] !== ariaLabel || $[8] !== contentProps || $[9] !== t1 || $[10] !== t2) {
    t3 = <CustomContent ariaLabel={ariaLabel} contentProps={contentProps} hideScrollButtons={t1}>{t2}</CustomContent>;
    $[7] = ariaLabel;
    $[8] = contentProps;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default SelectContent;